import React from "react";
import Container from "./Container";

// Standard top-of-page block: 40px/700 heading, muted subtitle, optional aside
// (usually a StatStrip). Keeps every inner page starting the same way.
const PageHeader = ({ title, subtitle, meta, aside, children }) => (
  <Container className="pt-10 pb-8 md:pt-12">
    <div className="flex flex-col gap-8 lg:flex-row lg:items-start lg:justify-between">
      <div className="max-w-2xl">
        <h1 className="text-3xl font-bold tracking-tight text-navy md:text-4xl">
          {title}
        </h1>
        {subtitle && <p className="mt-3 text-base text-muted">{subtitle}</p>}
        {meta && <div className="mt-3 text-sm text-muted">{meta}</div>}
      </div>
      {aside && <div className="w-full lg:w-auto lg:min-w-[36rem]">{aside}</div>}
    </div>
    {children}
  </Container>
);

export default PageHeader;
